<template>
  <div class="mydevice-bd tb">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click="exportTable"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input
            :placeholder="$t('asm_lockCleanDevice.ji_shen_hao')"
            v-model="formSearch.search"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <!-- 机身号 -->
        <el-form-item :label="$t('asm_lockCleanDevice.he_tong_bian_hao')">
          <el-input
            v-model="formSearch.contractNo"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 锁机后使用天数 -->
        <el-form-item :label="$t('asm_lockCleanDevice.sjhsyts')">
          <el-select v-model="formSearch.daysAfterLocked" clearable>
            <el-option
              v-for="item in daysAfterData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 锁机天数 -->
        <el-form-item :label="$t('asm_lockCleanDevice.suo_ji_tian_shu')">
          <el-select v-model="formSearch.lockedDays" clearable>
            <el-option
              v-for="item in lockedData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 库存方 -->
        <el-form-item :label="$t('asm_lockCleanDevice.ku_cun_fang')">
          <el-input
            v-model="formSearch.orgName"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 售后公司 -->
        <el-form-item :label="$t('asm_lockCleanDevice.shou_hou_gong_si')">
          <el-input
            v-model="formSearch.afterServiceName"
            clearable
          ></el-input>
        </el-form-item>
        <!-- 锁机时间 -->
        <el-form-item :label="$t('asm_lockCleanDevice.suo_ji_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.bizLockTime" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
        <!-- 清洁时间 -->
        <el-form-item :label="$t('asm_lockCleanDevice.qing_jie_shi_jian')">
          <custom-date-picker style="width: 100%" v-model="formSearch.cleaningTime" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
        </el-form-item>
        <!-- GPS地址 -->
        <el-form-item :label="$t('asm_lockCleanDevice.GPSdi_zhi')">
          <el-input
            v-model="formSearch.gpsAddress"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="customTb1"
        :column="tableColumn"
        :data="tableList"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
        :slots="['bodyNum','contractNo','locationSiteName']"
      >
        <template v-slot:bodyNum="scope">
          <span
            class="cell-link"
            @click="toDeviceDetail(scope.row)"
          >{{scope.row.bodyNum}}</span>
        </template>
        <template v-slot:contractNo="scope">
          <span
            class="cell-link"
            @click="toContractDetail(scope.row)"
          >{{scope.row.contractNo}}</span>
        </template>
        <template v-slot:locationSiteName="scope">
          {{`${scope.row.locationName}${scope.row.siteName ? '/' : ''}${scope.row.siteName}`}}
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import tableFilterValueMixins from '@/mixins/table_filterValue_mixins.js';

export default {
  name: 'lockCleanDevice',
  mixins: [resetFormSearchMixins, tableFilterValueMixins],
  data() {
    return {
      provide: true,
      tableCode: 'lock_clean_device',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        contractNo: '',
        minLockedUsageDays: '',
        minLockDays: '',
        orgName: '',
        agentCoName: '',
        afterServiceName: '',
        gpsAddress: '',
        bizLockStartTime: '',
        bizLockEndTime: '',
        lastCleanStartTime: '',
        lastCleanEndTime: '',
      },
      bizLockTime: [],
      cleaningTime: [],
      tableList: [],
      totalRows: null,
      link: null,
    };
  },
  computed: {
    daysAfterData() {
      return [
        { label: this.$t('asm_lockCleanDevice.3tian'), value: 3 },
        { label: this.$t('asm_lockCleanDevice.7tian'), value: 7 },
        { label: this.$t('asm_lockCleanDevice.30tian'), value: 30 },
        { label: this.$t('asm_lockCleanDevice.60tian'), value: 60 },
      ];
    },
    lockedData() {
      return [
        { label: this.$t('asm_lockCleanDevice.7tian'), value: 7 },
        { label: this.$t('asm_lockCleanDevice.30tian'), value: 30 },
        { label: this.$t('asm_lockCleanDevice.60tian'), value: 60 },
      ];
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;

      }, 500);
    });
    this.getTableList();
  },
  methods: {
    setSearchTime(timeArrayName, startTimeName, endTimeName) {
      const timeArray = this.formSearch[timeArrayName];
      this.formSearch[startTimeName] = timeArray && timeArray[0] ? timeArray[0] : undefined;
      this.formSearch[endTimeName] = timeArray && timeArray[1] ? timeArray[1] : undefined;
    },
    getTableList() {
      this.setSearchTime('bizLockTime', 'bizLockStartTime', 'bizLockEndTime');
      this.setSearchTime('cleaningTime', 'lastCleanStartTime', 'lastCleanEndTime');
      this.fetchTableData();
    },
    fetchTableData() {
      this.$getJSON(apis.lockCleanPage, { ...this.formSearch }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    exportTable() {
      this.setSearchTime('bizLockTime', 'bizLockStartTime', 'bizLockEndTime');
      this.setSearchTime('cleaningTime', 'lastCleanStartTime', 'lastCleanEndTime');
      this.$exportFlie(apis.lockCleanExport, { ...this.formSearch }).then(() => {});
    },
    toDeviceDetail(row) {
      this.jump('/devicedetail', { bodyNum: row.bodyNum, parentPath: this.$route.path });
    },
    toContractDetail(row) {
      this.jump('/contractdetail', { contractId: row.orderId, contractClass: row.orderType, parentPath: this.$route.path });
    },
  },
};
</script>

<style lang="scss">
.mydevice-bd {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 200px;
    display: flex;
    .g2-p1 {
      width: 800px;
      height: 220px;
      & > div {
        top: -50px;
        left: -20px;
      }
    }
    .g2-p2 {
      width: 400px;
      height: 200px;
      & > div {
        left: -220px;
      }
    }
  }
  .product-wrap {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    margin-top: 16px;
    background-color: #ffffff;
  }
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
